import { apiSlice, createClientV2QueryFn } from 'store/slices/api';
import { CLIENT_V2_URLS } from 'store/slices/constants/clientV2';
import { parseQueryParams } from 'store/slices/utils';
import { ListResponse, QueryParams } from 'types/api';
import { TeamSchema } from 'types/clientV2/teams';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTeamsClientV2: builder.query<
      ListResponse<TeamSchema>,
      QueryParams<TeamSchema>
    >({
      queryFn: createClientV2QueryFn<
        ListResponse<TeamSchema>,
        QueryParams<TeamSchema>
      >((params) => CLIENT_V2_URLS.TEAMS(parseQueryParams<TeamSchema>(params))),
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(
                ({ id }: TeamSchema) => ({ type: 'Teams', id } as const)
              ),
              { type: 'Teams', id: 'LIST' },
            ]
          : [{ type: 'Teams', id: 'LIST' }],
    }),
  }),
});

export const { useGetTeamsClientV2Query } = extendedApiSlice;
